import { Heading_default } from "./chunk-BV6IPKD7.js";
import { Figure_default } from "./chunk-AN4JJSLI.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Banner/Banner.tsx
import { useMemo, cloneElement, forwardRef } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var BANNER_CLASSNAME_MAP = {
  variant: {
    horizontal: "pd:banner--horizontal",
    vertical: "pd:banner--vertical",
    "dim-horizontal": "pd:banner--dim-horizontal",
    "dim-vertical": "pd:banner--dim-vertical"
  },
  justify: {
    start: "pd:banner--justify-start",
    center: "pd:banner--justify-center",
    end: "pd:banner--justify-end"
  }
};
var Banner = forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      title: titleProp,
      image,
      button,
      link,
      className,
      justify = "start",
      variant = "horizontal"
    } = _b,
    rest = __objRest(_b, ["children", "title", "image", "button", "link", "className", "justify", "variant"]);
  const title = useMemo(() => {
    var _a2;
    if (link) {
      return cloneElement(link, {
        children: /* @__PURE__ */jsx("span", {
          children: titleProp
        }),
        className: clsx("pd:banner__link", (_a2 = link.props) == null ? void 0 : _a2.className)
      });
    }
    return titleProp;
  }, [link, titleProp]);
  return /* @__PURE__ */jsxs(Figure_default, __spreadProps(__spreadValues({
    ref,
    className: clsx("pd:nested-actions", "pd:banner", BANNER_CLASSNAME_MAP.justify[justify], BANNER_CLASSNAME_MAP.variant[variant], className)
  }, rest), {
    children: [/* @__PURE__ */jsx("div", {
      className: "pd:banner__image",
      children: image
    }), /* @__PURE__ */jsxs("div", {
      className: "pd:banner__content",
      children: [/* @__PURE__ */jsx(Heading_default, {
        as: "figcaption",
        size: "1",
        className: "pd:banner__heading",
        children: title
      }), (children || button) && /* @__PURE__ */jsxs("div", {
        className: "pd:banner__description",
        children: [children, /* @__PURE__ */jsx("div", {
          className: "pd:banner__button",
          children: button
        })]
      })]
    })]
  }));
});
var Banner_default = Banner;
export { BANNER_CLASSNAME_MAP, Banner_default };